module.exports = __webpack_public_path__ + "img/bg-card.5d53dd02.svg";